/**
 * Stable CSS class names for E2E — Return / Edit bank account drawer content.
 */
export const RCEDC = {
    root: 'return-card-edit-drawer-content',
    headerRoot: 'return-card-edit-drawer-content__header',
    headerTitle: 'return-card-edit-drawer-content__header-title',
    headerCloseIcon: 'return-card-edit-drawer-content__header-close-icon',

    form: 'return-card-edit-drawer-content__form',
    container: 'return-card-edit-drawer-content__container',
    fieldsGrid: 'return-card-edit-drawer-content__fields-grid',
    fieldGridItem: 'return-card-edit-drawer-content__field-grid-item',

    fieldWrap: 'return-card-edit-drawer-content__field',
    fieldAutocompleteWrap: 'return-card-edit-drawer-content__field-autocomplete-wrap',
    fieldHelperText: 'return-card-edit-drawer-content__field-helper-text',
    fieldText: 'return-card-edit-drawer-content__field-text',

    submitRow: 'return-card-edit-drawer-content__submit-row',
    submitButton: 'return-card-edit-drawer-content-input--button-submit',
} as const;

export const rcedcCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

